module.exports = __webpack_public_path__ + "static/media/hubspot.f22745cf.svg";